function injectStyle (ssrContext) {
  require("!!../../../../_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../_vue-loader@12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-780b2265\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../_vue-loader@12.2.2@vue-loader/lib/selector?type=styles&index=0!./search.vue")
}
var Component = require("!../../../../_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./search.vue"),
  /* template */
  require("!!../../../../_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-780b2265\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./search.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-780b2265",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_xiaozhu@2022.4.8@xiaozhu/vue/components/admin/search.vue
// module id = 97
// module chunks = 49